import randomId from 'random-id';
import { getCollectionFields } from '../pluginComponentApi';
import { filterFieldsForForm } from '../../fields/FieldTypes';
import {
  URLFields,
  StringFields,
  SelectOptionFields,
  MultiSelectOptionFields,
  FieldTypes,
} from 'drapcode-constant';
const {
  number,
  large_text,
  reference,
  belongsTo,
  date,
  boolean,
  multi_image,
  slug,
  color,
  time_picker,
} = FieldTypes;
export const getFormComponents = async (collectionName, collections) => {
  const collection = await getCollectionFields(collectionName, collections);
  return collection;
};
export const createFormForCollection = async (
  collection,
  projectId,
  version,
  collections,
  isUpdateForm = false,
) => {
  const fields = filterFieldsForForm(collection.fields);
  let formData = fields.map(async (field, key) => {
    return await renderText(field, projectId, version, collections, isUpdateForm);
  });
  return (await Promise.all(formData)).join('');
};

const getInnerFormComponents = async (
  collectionName,
  projectId,
  version,
  collections,
  parentFieldName,
) => {
  const collection = await getCollectionFields(collectionName, collections);
  const fields = collection ? filterFieldsForForm(collection.fields) : [];
  let formData = fields.map(async (field, key) => {
    const newField = Object.assign({}, field);
    newField.fieldName = parentFieldName + '.' + field.fieldName;
    return await renderText(newField, projectId, version, collections);
  });
  let formDataList = await Promise.all(formData);
  formDataList = [
    ...formDataList,
    `<input class="input form-control" type="hidden" name="${parentFieldName}.uuid"/>`,
  ];
  return formDataList.join('');
};
const renderText = async (field, projectId, version, collections, isUpdateForm = false) => {
  const {
    required,
    isMultiSelect,
    fieldName,
    type,
    fieldTitle,
    placeholder,
    extraFieldSetting,
    refCollection,
    validation,
  } = field;
  const isRequired = required ? 'required' : '';
  const isMultipleSelect = isMultiSelect ? 'multiple' : '';
  const formCheckboxId = 'dc-checkbox-' + randomId(8, '');
  const fileLabel = placeholder.en ? placeholder.en : fieldTitle.en ? fieldTitle.en : 'Select file';
  let textEditor = '';
  let dateTime = 'datetime-local';
  let timeFormat = '24_HOURS';
  if (extraFieldSetting) {
    const { textareaDisplayType, dateDisplayType } = extraFieldSetting;
    textEditor = textareaDisplayType === 'text-editor' ? 'data-show-editor="true"' : '';
    dateTime = dateDisplayType;
    timeFormat = dateDisplayType;
  }
  const collectionUpdateAttribute = isUpdateForm
    ? `data-form-element-collection='${fieldName}'`
    : '';

  if (StringFields.includes(type)) {
    return `<div class="form-group col-12 col-md-12">
            <label for="${fieldName}">${fieldTitle.en}</label>
            <input class="input form-control" type="${type}" name="${fieldName}" value="" placeholder="${placeholder.en}" ${collectionUpdateAttribute}/>
        </div>`;
  } else if (type === slug.id) {
    return `<div class="form-group col-12 col-md-12">
            <label for="${fieldName}">${fieldTitle.en}</label>
            <input class="input form-control" type="text" name="${fieldName}" value="" placeholder="${placeholder.en}" ${collectionUpdateAttribute}/>
        </div>`;
  } else if (type === color.id) {
    return `<div class="form-group col-12 col-md-12">
        <label class="label" for="${fieldName}">${fieldTitle.en}</label>
        <div style=" align-items: center;" >
            <input id="${fieldName}" class="input form-control" type='text' data-coloris
     name="${fieldName}" value="#c22467" placeholder="${placeholder.en}" readonly />
        </div>
    </div>
`;
  } else if (type === number.id) {
    return `<div class="form-group col-12 col-md-12">
            <label for="${fieldName}">${fieldTitle.en}</label>
            <input class="input form-control" step="any" type="${type}" name="${fieldName}" value="" placeholder="${placeholder.en}" ${collectionUpdateAttribute}/>
        </div>`;
  } else if (type === large_text.id) {
    return `<div class="form-group col-12 col-md-12">
            <label  for="${fieldName}">${fieldTitle.en}</label>
            <textarea class="textarea form-control" col="20" rows="10" ${textEditor} name="${fieldName}" placeholder="${placeholder.en}" ${collectionUpdateAttribute}></textarea>
        </div>`;
  } else if (
    SelectOptionFields.includes(type) &&
    (refCollection.isShowAsRadioOrCheckBox || refCollection.displayType === 'asRadioOrCheckbox')
  ) {
    if (isMultiSelect) {
      return `
      <div class="form-group col-12 col-md-12 d-flex flex-column">
       <label for="${fieldName}">${fieldTitle.en}</label>
        <div class="col-12 col-md-12 d-flex flex-column">
          <input  type="checkbox" name="${fieldName}" id="${fieldName}" class="form-check-input dc-checkbox" data-component-type="select"
          ${collectionUpdateAttribute} />
          <label class="form-check-label" for="${fieldName}">${fieldTitle.en}</label>
        </div>
      </div>
      `;
    } else {
      return `
      <div class="form-group col-12 col-md-12 d-flex flex-column">
        <label for="${fieldName}">${fieldTitle.en}</label>
        <div class="col-12 col-md-12 d-flex flex-column">
          <input name="${fieldName}"  type="radio" id="${fieldName}" class="form-check-input dc-radio" ${collectionUpdateAttribute}/>
          <label class="form-radio-label" for="${fieldName}">${fieldTitle.en}</label>
        </div>
      </div>
      `;
    }
  } else if (
    (type === reference.id &&
      refCollection.isShowAsText === true &&
      refCollection.displayType === 'dropdown') ||
    (type === belongsTo.id && refCollection.isShowAsText === true)
  ) {
    return `<div class="form-group col-12 col-md-12">
              <input class="input form-control" type="text" name="${fieldName}" value="" placeholder="${placeholder.en}" ${collectionUpdateAttribute}/>
            </div>`;
  } else if (
    (type === reference.id && refCollection.displayType === 'dropdown') ||
    MultiSelectOptionFields.includes(type)
  ) {
    return `<div class="form-group col-12 col-md-12">
             <label for="${fieldName}">${fieldTitle.en}</label>
               <select class="select form-control" name="${fieldName}" ${isRequired} ${isMultipleSelect} ${collectionUpdateAttribute}>
              </select>
            </div>`;
  } else if (type === reference.id && refCollection.displayType === 'innerForm') {
    return await getInnerFormComponents(
      refCollection.collectionName,
      projectId,
      version,
      collections,
      fieldName,
    );
  } else if (type === date.id) {
    if (dateTime === 'date-segregated') {
      return `<div class="form-group col-12 col-md-12" data-gjs="date-segregated-container">
                <label  for="${fieldName}">${fieldTitle.en}</label>
                <div class="mx-auto d-flex gap-4">
                  <select class="select form-control" name="${fieldName}" ${isRequired} ${collectionUpdateAttribute} date-segregated="month" data-component-type="date" data-field-name="${fieldName}" data-field-title="Month"><option value="">- Select Month -</option></select>
                  <select class="select form-control" name="${fieldName}" ${isRequired} ${collectionUpdateAttribute} date-segregated="day" data-component-type="date" data-field-name="${fieldName}" data-field-title="Date"><option value="">- Select Day -</option></select>
                  <select class="select form-control" name="${fieldName}" ${isRequired} ${collectionUpdateAttribute} date-segregated="year" data-component-type="date" data-field-name="${fieldName}" data-field-title="Year"><option value="">- Select Year -</option></select>
                </div>
              </div>`;
    } else {
      return `<div class="form-group col-12 col-md-12">
              <label  for="${fieldName}">${fieldTitle.en}</label>
              <input class="input form-control" type="${dateTime}" name="${fieldName}" ${isRequired} value="" placeholder="${placeholder.en}" ${collectionUpdateAttribute}/>
            </div>`;
    }
  } else if (type === boolean.id) {
    return `<div class="form-group col-12 col-md-12 d-flex flex-column">
                  <input id="${formCheckboxId}" type="checkbox" class="form-check-input dc-checkbox" name="${fieldName}" ${collectionUpdateAttribute} />
                  <label class="form-check-label" for="${formCheckboxId}">${fieldTitle.en}</label>
              </div>`;
  } else if (URLFields.includes(type)) {
    let { noAllowedFiles } = validation;
    noAllowedFiles = noAllowedFiles ? noAllowedFiles : 1;
    const isMultiple = noAllowedFiles > 1 ? 'multiple="true"' : '';
    return `<div class="form-group col-12 col-md-12">
                  <label  for="${fieldName}">${fieldTitle.en}</label>
                  <div class="custom-file">
                     <input type="file" onchange="fileUpload(event)" class="custom-file-input" ${isMultiple} id="${fieldName}" name="${fieldName}" data-max-file="${noAllowedFiles}" ${collectionUpdateAttribute}>
                     <label class="file-list-display custom-file-label" for="${fieldName}" data-browse="Browse">${fileLabel}</label>
                     <input type="hidden" name="${fieldName}"/>
                   </div>
             </div> `;
  } else if (type === multi_image.id) {
    return `<div class="form-group col-12 col-md-12">
                  <label for="${fieldName}">${fieldTitle.en}</label>
                  <div class="custom-file">
                     <input type="file" onchange="fileUpload(event)" class="custom-file-input"  multiple id="${fieldName}" name="${fieldName}">
                     <label class="file-list-display custom-file-label" for="${fieldName}" data-browse="Browse">${fileLabel}</label>
                     <input type="hidden" name="${fieldName}"/>
                   </div>
             </div>`;
  } else if (type === time_picker.id) {
    return `<div class="form-group col-12 col-md-12">
      <label for="${fieldName}">${fieldTitle.en}</label>          
      <input class="input form-control timepicker" type="text" name="${fieldName}" value="" placeholder="${placeholder.en}" data-component-type="${type}" data-timeformat="${timeFormat}" ${collectionUpdateAttribute}/>
    </div>`;
  }
};

export const getCollectionFieldElements = async (
  field,
  projectId,
  version,
  collections,
  isUpdateForm = false,
) => {
  const {
    required,
    isMultiSelect,
    fieldName,
    type,
    fieldTitle,
    placeholder,
    extraFieldSetting,
    refCollection,
    validation,
  } = field;
  const isRequired = required ? 'required' : '';
  const isMultipleSelect = isMultiSelect ? 'multiple' : '';
  const formCheckboxId = 'dc-checkbox-' + randomId(8, '');
  const fileLabel = placeholder.en ? placeholder.en : fieldTitle.en ? fieldTitle.en : 'Select file';
  const collectionUpdateAttribute = isUpdateForm
    ? `data-form-element-collection='${fieldName}'`
    : '';
  let textEditor = '';
  let dateTime = 'datetime-local';
  let timeFormat = '24_HOURS';
  console.log('🚀 ~ getCollectionFieldElements ~ extraFieldSetting:', extraFieldSetting);
  if (extraFieldSetting) {
    const { textareaDisplayType, dateDisplayType } = extraFieldSetting;
    textEditor = textareaDisplayType === 'text-editor' ? 'data-show-editor="true"' : '';
    dateTime = dateDisplayType;
    timeFormat = dateDisplayType;
  }
  if (StringFields.includes(type)) {
    return `<div data-gjs-type="collection-field" class="form-group col-12">
              <label for="${fieldName}">${fieldTitle.en}</label>
              <input class="input form-control" type="${type}" name="${fieldName}" value="" placeholder="${placeholder.en}" ${collectionUpdateAttribute}/>
          </div>`;
  } else if (type === number.id) {
    return `<div data-gjs-type="collection-field" class="form-group col-12">
              <label for="${fieldName}">${fieldTitle.en}</label>
              <input class="input form-control" step="any" type="${type}" name="${fieldName}" value="" placeholder="${placeholder.en}" ${collectionUpdateAttribute}/>
          </div>`;
  } else if (type === large_text.id) {
    return `<div data-gjs-type="collection-field" class="form-group col-12">
              <label  for="${fieldName}">${fieldTitle.en}</label>
              <textarea class="textarea form-control" col="20" rows="10" ${textEditor} name="${fieldName}" placeholder="${placeholder.en}" ${collectionUpdateAttribute}></textarea>
          </div>`;
  } else if (
    SelectOptionFields.includes(type) &&
    (refCollection.isShowAsRadioOrCheckBox || refCollection.displayType === 'asRadioOrCheckbox')
  ) {
    if (isMultiSelect) {
      return `
      <div class="form-group col-12 col-md-12 d-flex flex-column">
       <label for="${fieldName}">${fieldTitle.en}</label>
        <div class="col-12 col-md-12 d-flex flex-column">
          <input data-gjs-type="checkbox" type="checkbox" name="${fieldName}" id="${fieldName}" class="form-check-input dc-checkbox" data-component-type="select"
          ${collectionUpdateAttribute} />
          <label class="form-check-label" for="${fieldName}">${fieldTitle.en}</label>
        </div>
      </div>
      `;
    } else {
      return `
        <div class="form-group col-12 col-md-12 d-flex flex-column">
        <label for="${fieldName}">${fieldTitle.en}</label>
        <div class="form-group col-12 col-md-12 d-flex flex-column">
          <input name="${fieldName}" data-gjs-type="radio"  type="radio" id="${fieldName}" class="form-check-input dc-radio" ${collectionUpdateAttribute}/>
          <label class="form-radio-label" for="${fieldName}">${fieldTitle.en}</label>
        </div>
        </div>
        `;
    }
  } else if (
    (type === reference.id &&
      refCollection.isShowAsText === true &&
      refCollection.displayType === 'dropdown') ||
    (type === belongsTo.id && refCollection.isShowAsText === true)
  ) {
    return `<div data-gjs-type="collection-field" class="form-group col-12">
                <input class="input form-control" type="text" name="${fieldName}" value="" placeholder="${field.placeholder.en}" ${collectionUpdateAttribute}/>
              </div>`;
  } else if (
    (type === reference.id && refCollection.displayType === 'dropdown') ||
    MultiSelectOptionFields.includes(type)
  ) {
    return `<div data-gjs-type="collection-field" class="form-group col-12">
              <label for="${fieldName}">${fieldTitle.en}</label>
              <select class="select form-control" name="${fieldName}"
                ${isRequired} ${isMultipleSelect} ${collectionUpdateAttribute}>
              </select>
          </div>`;
  } else if (type === reference.id && refCollection.displayType === 'innerForm') {
    return await getInnerFormComponents(
      refCollection.collectionName,
      projectId,
      version,
      collections,
      fieldName,
    );
  } else if (type === date.id) {
    if (dateTime === 'date-segregated') {
      return `<div data-gjs-type="collection-field" class="form-group col-12" data-gjs="date-segregated-container">
                <label  for="${fieldName}">${fieldTitle.en}</label>
                <div class="mx-auto d-flex gap-4">
                  <select class="select form-control" name="${fieldName}" ${isRequired} ${collectionUpdateAttribute} date-segregated="month" data-component-type="date" data-field-name="${fieldName}" data-field-title="Month"><option value="">- Select Month -</option></select>
                  <select class="select form-control" name="${fieldName}" ${isRequired} ${collectionUpdateAttribute} date-segregated="day" data-component-type="date" data-field-name="${fieldName}" data-field-title="Date"><option value="">- Select Day -</option></select>
                  <select class="select form-control" name="${fieldName}" ${isRequired} ${collectionUpdateAttribute} date-segregated="year" data-component-type="date" data-field-name="${fieldName}" data-field-title="Year"><option value="">- Select Year -</option></select>
                </div>
              </div>`;
    } else {
      return `<div data-gjs-type="collection-field" class="form-group col-12 ">
              <label  for="${fieldName}">${fieldTitle.en}</label>
              <input class="input form-control" type="${dateTime}" name="${fieldName}" ${isRequired}
                     value="" placeholder="${placeholder.en}" ${collectionUpdateAttribute}/>
          </div>`;
    }
  } else if (type === boolean.id) {
    return `<div data-gjs-type="collection-field" class="form-group col-12 d-flex flex-column">
                    <input id="${formCheckboxId}" type="checkbox" class="form-check-input dc-checkbox" name="${fieldName}" ${collectionUpdateAttribute} />
                    <label class="form-check-label" for="${formCheckboxId}">${fieldTitle.en}</label>
                </div>`;
  } else if (URLFields.includes(type)) {
    let { noAllowedFiles } = validation;
    noAllowedFiles = noAllowedFiles ? noAllowedFiles : 1;
    const isMultiple = noAllowedFiles > 1 ? 'multiple="true"' : '';
    return `<div data-gjs-type="collection-field" class="form-group col-12">
                    <label  for="${fieldName}">${fieldTitle.en}</label>
                    <div class="custom-file">
                       <input type="file" onchange="fileUpload(event)" class="custom-file-input" ${isMultiple} id="${fieldName}" name="${fieldName}" data-max-file="${noAllowedFiles}" ${collectionUpdateAttribute}>
                     <label class="file-list-display custom-file-label" for="${fieldName}" data-browse="Browse">${fileLabel}</label>
                       <input type="hidden" name="${fieldName}"/>
                     </div>
               </div> `;
  } else if (type === multi_image.id) {
    return `<div class="custom-file">
                     <input type="file" onchange="fileUpload(event)" class="custom-file-input"  multiple id="${fieldName}" name="${fieldName}">
                     <label class="file-list-display custom-file-label" for="${fieldName}" data-browse="Browse">${fileLabel}</label>
                       <input type="hidden" name="${fieldName}"/>
                     </div>
               </div> `;
  } else if (type === color.id) {
    return `<div class="form-group col-12 col-md-12">
        <label class="label" for="${fieldName}">${fieldTitle.en}</label>
        <div style=" align-items: center;" >
            <input id="${fieldName}" class="input form-control" type='text' data-coloris
     name="${fieldName}" value="#c22467" placeholder="${placeholder.en}" readonly />
        </div>
    </div>`;
  } else if (type === slug.id) {
    return `<div class="form-group col-12 col-md-12">
            <label for="${fieldName}">${fieldTitle.en}</label>
            <input class="input form-control" type="text" name="${fieldName}" value="" placeholder="${placeholder.en}" ${collectionUpdateAttribute}/>
        </div>`;
  } else if (type === time_picker.id) {
    return `<div class="form-group col-12 col-md-12">
      <label for="${fieldName}">${fieldTitle.en}</label>
      <input class="input form-control timepicker" type="text" name="${fieldName}" value="" placeholder="${placeholder.en}" data-component-type="${type}" data-timeformat="${timeFormat}" ${collectionUpdateAttribute}/>
    </div>`;
  }
};
